import React, { useState } from 'react';
import { FileText, Copy, ChevronUp, ChevronDown } from 'lucide-react';

export const TranscriptViewer = ({ transcript, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!transcript) return null;

  const copy = (e) => {
    e.stopPropagation();
    try { navigator.clipboard.writeText(transcript); } catch { /* noop */ }
  };

  return (
    <div className="mb-6" data-testid="transcript-viewer">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-4 bg-gray-800/50 border border-gray-700 rounded-xl"
        data-testid="transcript-toggle-btn"
      >
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5 text-gray-400" />
          <span className="text-gray-300 font-medium">Call Transcript</span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={copy} className="p-1.5 hover:bg-gray-700 rounded" title="Copy transcript">
            <Copy className="w-4 h-4 text-gray-500" />
          </button>
          {open ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
        </div>
      </button>
      {open && (
        <div className="mt-2 p-4 bg-[#1a1a1f] rounded-xl border border-gray-700 max-h-60 overflow-y-auto">
          <pre className="text-gray-300 text-sm whitespace-pre-wrap font-mono">{transcript}</pre>
        </div>
      )}
    </div>
  );
};
